import { compact } from 'lodash'
import { FarmManager } from 'modules/farm/api/types'
import { useMemo } from 'react'

import { RoleName } from '../constants'
import {
  useGetFarmGroup,
  useGetFeatures,
  useGetManagers,
  useGetMembers,
  useGetRoles,
  useGetRolesPreset,
} from './queries'

// Deprecated
export const useManagers = () => {
  const { data, ...rest } = useGetManagers()

  return useMemo(
    () => ({
      ...rest,
      data: (data ?? []).map((manager) => ({
        id: manager.id,
        name: manager.name,
        photo: manager?.pictureURL,
      })) as FarmManager[] | [],
    }),

    [data, rest.isFetching]
  )
}

export const useMembers = () => {
  const { data, ...rest } = useGetMembers()
  return useMemo(
    () => ({
      ...rest,
      data,
    }),
    [data, rest.isFetching]
  )
}

export const useRoles = () => {
  const { data, ...rest } = useGetRoles()
  return useMemo(
    () => ({
      ...rest,
      data,
    }),
    [data, rest.isFetching]
  )
}

export const useFeatures = () => {
  const { data, ...rest } = useGetFeatures()
  return useMemo(
    () => ({
      ...rest,
      data,
    }),
    [data, rest.isFetching]
  )
}

export const useRolesPreset = () => {
  const { data, ...rest } = useGetRolesPreset()
  return useMemo(
    () => ({
      ...rest,
      data,
    }),
    [data, rest.isFetching]
  )
}

export const useFarmGroup = (search: string | null, options?: { enabled?: boolean }) => {
  const { data, ...rest } = useGetFarmGroup(search, options)
  return useMemo(
    () => ({ ...rest, data: compact((data?.pages ?? []).map((page) => page.farmGroups).flat()) }),

    [data]
  )
}

export const useGetRolesWithoutPrimaryOwner = () => {
  const { data, ...rest } = useGetRoles()
  return useMemo(
    () => ({
      ...rest,
      data: data?.filter((el) => el.name !== RoleName.PrimaryOwner),
    }),
    [data, rest.isFetching]
  )
}
